import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VProgressCircular,{staticClass:"mx-auto d-block my-16",attrs:{"size":100,"width":5,"color":"lime","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }